import request from "@/utils/request";

export function getGyroscope(data) {
  return request({
    url: "Gyroscope/GetGyroscope",
    method: "post",
    data,
  });
}
export function getLength(data) {
  return request({
    url: "Gyroscope/GetGyroscopeAllLength",
    method: "post",
    data,
  });
}


// WEBPACK FOOTER //
// ./src/api/gyroscope.js